
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const templateApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listTemplates: builder.query ({
      query: (params) => `v2/template/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Template"]
    }),
    getTemplate: builder.query ({
      query: (template_id) => `v2/template/${template_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Template"]
    }),
    getTemplateLayouts: builder.query ({
      query: (template_id) => `v2/comboinlayout/?combo=${template_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["ComboInLayout"]
    }),
    updateTemplate: builder.mutation ({
      query: ({template_id, data}) => ({
        url: `v2/template/${template_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Template"]
    }),
    deleteTemplate: builder.mutation ({
      query: (template_id) => ({
        url: `v2/template/${template_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Template"]
    }),
    createTemplate: builder.mutation ({
      query: (data) => ({
        url: `v2/template/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Template"]
    }),
  })
})


export const {
  useListTemplatesQuery,
  useLazyListTemplatesQuery,
  useGetTemplateQuery,
  useLazyGetTemplateQuery,
  useGetTemplateLayoutsQuery,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
  useCreateTemplateMutation
} = templateApi
